import { useFeature } from '@features/FeatureToggle';
import { useMemo } from 'react';

const STRIPE_API_KEY = process.env.NEXT_PUBLIC_STRIPE_API_KEY as string;
const STRIPE_API_KEY_US = process.env.NEXT_PUBLIC_STRIPE_API_KEY_US as string;

let stripeInstance: any = null;
let currentApiKey: string | null = null;

export const useGetStripePromise = () => {
  const isVariantUsEnabled = useFeature('usFeature');
  const apiKey = isVariantUsEnabled ? STRIPE_API_KEY_US : STRIPE_API_KEY;

  return useMemo(async () => {
    if (!stripeInstance || currentApiKey !== apiKey) {
      const { loadStripe } = await import('@stripe/stripe-js');
      stripeInstance = await loadStripe(apiKey);
      currentApiKey = apiKey;
    }
    return stripeInstance;
  }, [apiKey]);
};
